import axios from "../../apiFc24";

export type SaveOrShareSquadRequestData = {
  name?: string;
  formation: string;
  players: {
    playerRoleId: number;
    resourceId: number;
    evoPathId?: number;
  }[];
  tacticId?: string;
  manager: {
    countryId: number;
    leagueId: number;
  };
  tactic?: {
    name: string;
    description: string;
    logoUrl: string;
    teamTactics: {
      buildUpStyle: string;
      formationId: string;
      defensiveApproach: string;
      lineHeight: number;
    };
    playerRoles: {
      playerRoleId: number;
      focus?: string;
    }[];
  };
};

export type SaveSquadRes = {
  id: string;
  tacticId: string;
  name: string;
};

export const saveSquad = async (
  data: SaveOrShareSquadRequestData,
): Promise<SaveSquadRes> => {
  const res = await axios.post("/saved-squads", data);
  return res.data;
};
